<a class="Question" *ngIf="data.contactEmail && data.separateQuestionIcon" [attr.href]="getMailToAddress(data.contactEmail)"><span class="Ask">Ask a question</span></a>
<ul [ngClass]="data.separateQuestionIcon ? 'Icons' : 'ActionIcons'">
  <li *ngIf="data.contactEmail && !data.separateQuestionIcon">
    <a class="Question" [attr.href]="getMailToAddress(data.contactEmail)" matTooltip="Ask a question or request an update" matTooltipPosition="below"></a>
  </li>
  <li>
    <icullen-favorite [uniqueNumber]="data.uniqueNumber" [isFavoriteDoc]="data.isFavoriteDoc" (favoriteChanged)="onFavoriteChanged($event)"></icullen-favorite>
    <!-- <a class="Favorites" [ngClass]="{'Favorites--selected': data.isFavoriteDoc}" (click)="toggleFavorite()">
      <span class="Add" matTooltip="Add to favorites" matTooltipPosition="above"></span>
      <span class="Remove" matTooltip="Remove from favorites" matTooltipPosition="above"></span>
   </a> -->
  </li>
  <!-- <li>
    <a class="Print" (click)="printDocClicked()" href="/product/pdf/{{data.uniqueNumber}}" target="_blank" matTooltip="Print document" matTooltipPosition="above"></a>
  </li>
  <li>
    <a Class="Pdf" (click)="generatePdfClicked()" href="/product/pdf/{{data.uniqueNumber}}" target="_blank" matTooltip="Generate a PDF" matTooltipPosition="above"></a>
  </li> -->
  <li *ngIf="!data.publication && data.accessType != 'PROSPECT_ACCESS'">
    <a class="PrintPdf" (click)="printDocClicked()" href="{{getPdfUrl()}}" target="_blank" matTooltip="Print document or Generate a PDF" matTooltipPosition="below"></a>
  </li>
  <li *ngIf="data.canCorrectDocument">
    <a class="Edition"  href="{{getDocumentCorrectionUrl()}}" target="_blank" matTooltip="Edit document" matTooltipPosition="below"></a>
  </li>
</ul>
